<template>

    <Page>
        <div class="mt-6
            flex flex-col w-full justify-center items-center
            max-w-[880px] 2xl:max-w-[1100px] 3xl:max-w-[1300px]">
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-16 justify-center items-start w-full">
                <div class="flex flex-col gap-6">
                    <Image src="/connected-vehicles-logo.png" class="w-[90%] max-w-[300px] 2xl:max-w-[640px] mx-auto -ml-4" />
                </div>
                <Image src="/presidian-group-logo.png" class="w-[80%] max-w-[240px] 2xl:max-w-[600px] mx-auto -mt-6" />
            </div>
        </div>
        <div class="mt-10 2xl:mt-14 3xl:mt-20
                    text-base 2xl:text-xl 3xl:text-2xl 
                    max-w-[880px] 2xl:max-w-[1100px] 3xl:max-w-[1300px]">
            <h2 class="mb-4 font-semibold">
                The partnership between Presidian and Connected Vehicles brings together 
                two trusted leaders in automotive innovation and customer retention
            </h2>
            <ul class="flex flex-col gap-4 list-disc text-white/80 pl-5">
                <li class="pl-3">
                    Connected Vehicles innovates, builds, looks over the horizon.
                </li>

                <li class="pl-3">
                    We're structured to be fast, to pivot quickly and grab opportunities before competitors.
                </li>
            
                <li class="pl-3">
                    Our platform scales, allowing new automotive products to be added quickly 
                    and commercialised for ourselves, our dealers and our partners.
                </li>
                
                <li class="pl-3">
                    We're excited to have a partner in Presidian that can take our strengths to market quickly.
                </li>

            </ul>
            <p class="mt-4">
                With Presidian's financial strength and operational experience combined with 
                Connected Vehicles' cutting-edge technology and dealer-focused solutions, this 
                partnership delivers a powerful ecosystem that supports long-term success 
                for participating dealerships.
            </p>
        </div>
    </Page>
    
</template>